import type {RecentlyTouchedBranches} from '@github-ui/code-view-shared/contexts/RecentlyTouchedBranchesContext'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import {
  type RepoPullsDashboardLayoutResponse,
  RepoPullsDashboardLayoutResponseSchema,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_pulls_dashboard'

import {repoRouteBuilder} from '../config/repo-route-builder'
import {
  createRepoPullsProtoPersister,
  type LegacyRepoPullsDashboardLayoutPayload,
  normalizeLegacyRepoPullsLayout,
  REPO_PULLS_LAYOUT_PERSISTER_CONFIG,
} from '../helpers/repo-pulls-dashboard-proto'

export function buildRepoPullsDashboardLayoutRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repoPullsDashboardLayoutRoute', {
    path: '/:owner/:repo',
    queries: [
      mainQuery<RepoPullsDashboardLayoutResponse>({
        schema: RepoPullsDashboardLayoutResponseSchema,
        adapt: legacy => normalizeLegacyRepoPullsLayout(legacy as LegacyRepoPullsDashboardLayoutPayload),
        persister: createRepoPullsProtoPersister(
          RepoPullsDashboardLayoutResponseSchema,
          'repoPullsDashboardLayoutRoute',
          REPO_PULLS_LAYOUT_PERSISTER_CONFIG,
        ),
        queryDeps: ({params}) => {
          // TODO: this should be typesafe, not sure why it isn't typechecking
          const {owner, repo} = params as {owner: string; repo: string}
          return {pathname: `/${owner}/${repo}/pulls/_layout`}
        },
        staleTimeForNavigation: 30_000,
      }),
      {
        queryName: 'recentlyTouchedBranches',
        queryDeps: ({params}) => ({pathname: `/${params.owner}/${params.repo}/recently-touched-branches`}),
        queryFn: async queryKey => queryFnFetch<RecentlyTouchedBranches>(queryKey),
        type: QueryRouteQueryType.Deferred,
      },
    ],
  })
}

export const repoPullsDashboardLayoutRoute = buildRepoPullsDashboardLayoutRoute(repoRouteBuilder)
